/* Nordvale UI: header tint, scroll reveal, card tilt, page transitions, add to cart, product rails. */
/* Header: glass tint once the page scrolls. */
(function () {
  var hd = document.querySelector('.section-header'), on = null;
  if (!hd) return;
  function f() { var s = window.scrollY > 20; if (s !== on) { on = s; hd.classList.toggle('nv-scrolled', s); } }
  window.addEventListener('scroll', f, { passive: true }); f();
})();

/* Scroll reveal: sections and cards rise in with a 3D tilt. */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('nv-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px 12% 0px' });
  function scan() {
    document.querySelectorAll('.nv-sechd,.nv-card,.nv-promise,.nv-end-copy,#MainContent .grid__item,.product__info-wrapper,.product__media-wrapper,.collection-hero__inner').forEach(function (el) {
      if (el.__rv) return; el.__rv = 1;
      var sib = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--d', (Math.min(sib, 4) * 40) + 'ms');
      el.classList.add('nv-rv'); io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

/* Card tilt: product cards lean toward the cursor with a moving glare. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cur = null, raf = 0, ev = null;
  function apply() {
    raf = 0; if (!cur || !ev) return;
    var r = cur.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
    cur.style.setProperty('--ry', ((x - .5) * 12).toFixed(2) + 'deg');
    cur.style.setProperty('--rx', ((.5 - y) * 10).toFixed(2) + 'deg');
    cur.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); cur.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
  }
  document.addEventListener('pointermove', function (e) {
    var c = e.target.closest ? e.target.closest('.nv-card,.card-wrapper') : null;
    if (c !== cur) { if (cur) { cur.classList.remove('nv-tilt'); cur.style.removeProperty('--rx'); cur.style.removeProperty('--ry'); } cur = c; if (cur) cur.classList.add('nv-tilt'); }
    ev = e; if (cur && !raf) raf = requestAnimationFrame(apply);
  }, { passive: true });
})();

/* Navigation: warp the particles, morph the clicked product photo, show a scan line. Never delays the click. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var html = document.documentElement;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || /^\/(checkout|account\/logout)/.test(u.pathname)) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    try { sessionStorage.setItem('nvNav', Date.now()); } catch (err) {}
    var card = a.closest('.nv-card,.card-wrapper'), img = card && card.querySelector('.nv-ph img,.card__media img');
    if (img && /\/products\//.test(u.pathname)) {
      img.style.viewTransitionName = 'nv-prod';
      try { sessionStorage.setItem('nvProd', u.pathname); } catch (err) {}
    }
    html.classList.add('nv-leaving');
    if (window.nvWarp) window.nvWarp();
  });
  window.addEventListener('pageshow', function (e) {             // back/forward cache: reset everything
    html.classList.remove('nv-leaving');
    document.querySelectorAll('img[style*="view-transition-name"]').forEach(function (el) { el.style.viewTransitionName = ''; });
    if (e.persisted && window.nvWarp) window.nvWarp(0);
  });
})();

/* Add to cart without leaving the page: a light flies to the cart and the count updates. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setCount(cart, n) {
    if (!cart) return;
    var b = cart.querySelector('.cart-count-bubble');
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; cart.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '99+') + '</span><span class="visually-hidden">' + n + ' items</span>';
  }
  function done(btn, n) {
    var html0 = btn.innerHTML, cart = document.getElementById('cart-icon-bubble');
    btn.classList.remove('is-busy'); btn.classList.add('nv-added');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Added';
    setTimeout(function () { btn.classList.remove('nv-added'); btn.innerHTML = html0; }, 1700);
    if (!cart || reduce || !btn.animate) { setCount(cart, n); return; }
    var a = btn.getBoundingClientRect(), b = cart.getBoundingClientRect(), dot = document.createElement('i');
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, dx = b.left + b.width / 2 - x0, dy = b.top + b.height / 2 - y0;
    dot.className = 'nv-fly'; dot.style.left = x0 + 'px'; dot.style.top = y0 + 'px'; document.body.appendChild(dot);
    dot.animate([
      { transform: 'translate(-50%,-50%) scale(.6)', opacity: 0 },
      { transform: 'translate(calc(-50% + ' + dx * .45 + 'px),calc(-50% + ' + (dy * .45 - 90) + 'px)) scale(1.5)', opacity: 1, offset: .45 },
      { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(.35)', opacity: .3 }
    ], { duration: 720, easing: 'cubic-bezier(.45,0,.25,1)' }).onfinish = function () {
      dot.remove(); setCount(cart, n);
      cart.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.3,1.6,.5,1)' });
    };
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('nv-addform') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.nv-add');
    if (!btn || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var add = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { done(btn, cart.item_count); })
      .catch(function () { btn.classList.remove('is-busy'); form.submit(); });   // fall back to the normal cart page
  });
})();

/* Product rails: arrows scroll one card, dim at the ends, dots show position. */
(function () {
  function init(sec) {
    if (sec.__nv) return; sec.__nv = 1;
    var rail = sec.querySelector('.nv-rail'), prev = sec.querySelector('[data-dir="-1"]'), next = sec.querySelector('[data-dir="1"]'),
        dots = sec.querySelector('.nv-dots'), ar = sec.querySelector('.nv-arrows'), stepW = 0, maxW = 0, tk = false;
    if (!rail || !prev || !next) return;
    function m() { var c = rail.querySelector('.nv-card'); stepW = c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 18) : rail.clientWidth; maxW = rail.scrollWidth - rail.clientWidth; }
    function d() {
      prev.disabled = rail.scrollLeft <= 8; next.disabled = rail.scrollLeft >= maxW - 6;
      var n = Math.max(1, Math.round(maxW / stepW) + 1), cur = Math.round(rail.scrollLeft / stepW);
      if (dots.children.length !== n) { dots.innerHTML = ''; for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i')); }
      [].forEach.call(dots.children, function (x, i) { x.classList.toggle('on', i === Math.min(cur, n - 1)); });
      dots.style.display = n > 1 ? '' : 'none'; ar.style.visibility = maxW > 8 ? '' : 'hidden';
    }
    [prev, next].forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: stepW * (+b.dataset.dir), behavior: 'smooth' }); }); });
    rail.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { next.click(); e.preventDefault(); } if (e.key === 'ArrowLeft') { prev.click(); e.preventDefault(); } });
    rail.addEventListener('scroll', function () { if (tk) return; tk = true; requestAnimationFrame(function () { tk = false; d(); }); }, { passive: true });
    window.addEventListener('resize', function () { m(); d(); }); window.addEventListener('load', function () { m(); d(); }); m(); d();
  }
  function all() { document.querySelectorAll('[data-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
